import { render, staticRenderFns } from "./vote.vue?vue&type=template&id=39647238&scoped=true&"
import script from "./vote.vue?vue&type=script&lang=js&"
export * from "./vote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39647238",
  null
  
)

export default component.exports